import script from "./TrivariateUI.vue?vue&type=script&setup=true&lang=js"
export * from "./TrivariateUI.vue?vue&type=script&setup=true&lang=js"

import "./TrivariateUI.vue?vue&type=style&index=0&id=2f92b3e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f92b3e6"]])

export default __exports__